import PouchLoadService from "external-services/pouch-load-service/index";

const NS = 'CreateSections';

const template = require('./createSections.html');

export default function CreateSections(
  $filter, unregister
) {
  "ngInject";

  return {
    scope: true,
    bindToController: {
      sections: '=',
      isDisabled: '=',
      displayErrors: '='
    },
    controller: function () {},
    controllerAs: 'vm',
    restrict: 'E',
    template,
    link
  };

  function link($scope) {

    const vm = $scope.vm;

    //-- define public methods
    vm.addSection = addSection;
    vm.deleteSection = deleteSection;
    vm.moveUp = moveUp;
    vm.moveDown = moveDown;
    //-- listen
    var listeners = [];
    listeners.push($scope.$watch('sectionsForm.$valid', validUpdate));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    if (!vm.sections || !vm.sections.length) {
      addSection();
    }

    function addSection() {
      var sectionId = PouchLoadService.getNewId(['section'], true);
      vm.sections.push({
        name: '',
        order: vm.sections.length,
        type: 'section',
        _id: sectionId
      });
    }

    function moveUp(index, section) {
      var sectionAbove = vm.sections[index - 1];
      var aboveOrder = sectionAbove.order;
      sectionAbove.order = section.order;
      section.order = aboveOrder;
      vm.sections = $filter('orderBy')(vm.sections, 'order');
    }

    function moveDown(index, section) {
      var sectionBelow = vm.sections[index + 1];
      var belowOrder = sectionBelow.order;
      sectionBelow.order = section.order;
      section.order = belowOrder;
      vm.sections = $filter('orderBy')(vm.sections, 'order');
    }

    function deleteSection(index) {
      vm.sections.splice(index, 1);
    }

    function validUpdate() {
      $scope.vm.isDisabled = ($scope.sectionsForm) ? !$scope.sectionsForm.$valid : false;
    }
  }
}
